import * as yup from "yup"

export const validationSchema = yup.object().shape({
    type_tax_code: yup.string().label("Type tax code").required().min(2).max(3),
    type_tax_name: yup.string().label("Type tax name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional(),
})